import axios from 'axios'

class UsersAdminService {
  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  getUsers (client, searchText, enabled) {
    let url = `${process.env.API}${client}/users?`
    if (searchText != null && searchText.trim() !== '') {
      url += '&search=' + encodeURI(searchText)
    }
    if (enabled === 'yes') {
      url += '&enabled=true'
    } else if (enabled === 'no') {
      url += '&enabled=false'
    }

    return axios.get(url)
  }

  getUserData (client, userId) {
    return axios.get(`${process.env.API}${client}/users/${userId}`)
  }

  createUser (client, userData) {
    return axios.post(`${process.env.API}${client}/users`, userData)
  }

  updateUser (client, userId, userData) {
    return axios.put(`${process.env.API}${client}/users/${userId}`, userData)
  }
}

const usersAdmin = new UsersAdminService()

export default usersAdmin
export { usersAdmin }



// WEBPACK FOOTER //
// ./src/services/usersadmin.service.js